import { render, staticRenderFns } from "./AiCoverImageGenerator.vue?vue&type=template&id=96585190&scoped=true"
import script from "./AiCoverImageGenerator.vue?vue&type=script&lang=js"
export * from "./AiCoverImageGenerator.vue?vue&type=script&lang=js"
import style0 from "./AiCoverImageGenerator.vue?vue&type=style&index=0&id=96585190&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96585190",
  null
  
)

export default component.exports